import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { EMPTY_ROUTE } from "shared/constants/routes";

export default function useRefresh() {
  const history = useHistory();
  const location = useLocation();
  let handler: any;
  const refresh = () => {
    history.push(EMPTY_ROUTE);
    handler = setTimeout(() => history.push(location), 10);
  };

  useEffect(() => {
    return () => handler && clearTimeout(handler);
  }, [handler]);

  return refresh;
}
